import { render, staticRenderFns } from "./cloundorderdeal.vue?vue&type=template&id=36d3750b&scoped=true"
import script from "./cloundorderdeal.vue?vue&type=script&lang=js"
export * from "./cloundorderdeal.vue?vue&type=script&lang=js"
import style0 from "./cloundorderdeal.vue?vue&type=style&index=0&id=36d3750b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3750b",
  null
  
)

export default component.exports